import { TFunction } from 'i18next';
import { ReactElement } from 'react';

import { DurationIcon } from '@/components/PlanBenefitTile/components/DurationIcon';
import { PlanIcon } from '@/components/PlanBenefitTile/components/PlanIcon';
import { PriceIcon } from '@/components/PlanBenefitTile/components/PriceIcon';
import { SpeedIcon } from '@/components/PlanBenefitTile/components/SpeedIcon';

export type PlanBenefitTypesKeys =
  | 'bundle_validity'
  | 'plan'
  | 'speed'
  | 'price'
  | 'empty';

export type PlanBenefitVariantTypes = 'color' | 'grey';

type PlanBenefitDetails = Record<
  PlanBenefitTypesKeys,
  { icon: ReactElement | undefined; label: string }
>;

export const getPlanBenefitDetails = (
  t: TFunction,
  isDefaultBrand: boolean,
): PlanBenefitDetails => {
  return {
    bundle_validity: {
      icon: <DurationIcon variant={isDefaultBrand ? 'color' : 'grey'} />,
      label: t('plan_card.benefit.duration', 'Duration'),
    },
    plan: {
      icon: <PlanIcon variant={isDefaultBrand ? 'color' : 'grey'} />,
      label: t('plan_card.benefit.plan', 'Plan'),
    },
    speed: {
      icon: <SpeedIcon variant={isDefaultBrand ? 'color' : 'grey'} />,
      label: t('plan_card.benefit.speed', 'Speed'),
    },
    price: {
      icon: <PriceIcon variant={isDefaultBrand ? 'color' : 'grey'} />,
      label: t('plan_card.benefit.price', 'Price'),
    },
    empty: {
      icon: undefined,
      label: '',
    },
  };
};
